import oneInch from './images/1-inch.png';
import tenXCapital from './images/10-x-capital.png';
import aARMY from './images/aarmy.png';
import acalaNetwork from './images/acala-network.png';
import accredible from './images/accredible.png';
import agnetix from './images/agnetix.png';
import albedo from './images/albedo.png';
import amulet from './images/amulet.png';
import antaresLogo from './images/antares.png';
import apolloneuro from './images/apolloneuro.png';
import arbol from './images/arbol.png';
import arcana from './images/arcana.png';
import arrayLabsLogo from './images/array-labs-logo.png';
import astariaLogo from './images/astaria-logo.svg';
import astra from './images/astra.png';
import avalanche from './images/avalanche.png';
import axiomSpace from './images/axiom-space.png';
import begin from './images/begin.png';
import bev from './images/bev.png';
import bidNFTLogo from './images/bid-nft-logo.png';
import biobot from './images/biobot.png';
import bitcountry from './images/bitcountry.png';
import bjStudios from './images/bj-studios.png';
import blinkmoon from './images/blinkmoon.png';
import blockFi from './images/block-fi.png';
import blockdaemon from './images/blockdaemon.png';
import blocklords from './images/blocklords.png';
import blockswap from './images/blockswap.png';
import bokksu from './images/bokksu.png';
import botkeeper from './images/botkeeper.png';
import bushaLogo from './images/busha-logo.png';
import campground from './images/campground.png';
import caraway from './images/caraway.png';
import caribou from './images/caribou.png';
import cartaLogo from './images/carta-logo.png';
import cereNetwork from './images/cere-network.png';
import chingari from './images/chingari.png';
import claystack from './images/claystack.png';
import coinDCX from './images/coin-dcx.png';
import coinfund from './images/coinfund.png';
import commAppLogo from './images/comm-app-logo.png';
import cupCake from './images/cup-cake.png';
import customerIo from './images/customer-io.png';
import dClimate from './images/d-climate.png';
import dapix from './images/dapix.png';
import dapper from './images/dapper.png';
import deesse from './images/deesse.png';
import dexalot from './images/dexalot.png';
import dodoex from './images/dodoex.png';
import doublejumpLogo from './images/doublejump-logo.png';
import duraFi from './images/dura-fi.png';
import earth from './images/earth.png';
import elementFinance from './images/element-finance.png';
import equipmentShareColored from './images/equipment-share-colored.png';
import fandom from './images/fandom.png';
import farePlay from './images/fare-play.png';
import fireflyAerospace from './images/firefly-aerospace.png';
import flipside from './images/flipside.png';
import fomoPayLogo from './images/fomo-pay-logo.png';
import fonbnk from './images/fonbnk.png';
import freshCutLabs from './images/fresh-cut-labs.png';
import galaxyEco from './images/galaxy-eco.png';
import gamerGains from './images/gamer-gains.png';
import genies from './images/genies.png';
import gMIComputing from './images/gmi-computing.png';
import gnosisLogo from './images/gnosis-logo.png';
import goGoPool from './images/go-go-pool.png';
import goTenna from './images/go-tenna.png';
import goldenHearts from './images/golden-hearts.png';
import goodeggs from './images/goodeggs.png';
import gunzilla from './images/gunzilla.png';
import hedgehog from './images/hedgehog.png';
import hedron from './images/hedron.png';
import hike from './images/hike.png';
import hop from './images/hop.png';
import hubble from './images/hubble.png';
import humanode from './images/humanode.png';
import incept from './images/incept.png';
import inkFinanceLogo from './images/ink-finance-logo.png';
import iqprotocol from './images/iqprotocol.png';
import jetProtocol from './images/jet-protocol.png';
import jetty from './images/jetty.png';
import juul from './images/juul.png';
import k2 from './images/k2logo.png';
import kado from './images/kado.png';
import kafene from './images/kafene.png';
import kibo from './images/kibo.png';
import klarna from './images/klarna.png';
import kraken from './images/kraken.png';
import loraDiCarlo from './images/lora-di-carlo.png';
import loverboy from './images/loverboy.png';
import ltse from './images/ltse.png';
import lucidsight from './images/lucidsight.png';
import magpieLogo from './images/magpie-logo.png';
import merkleScience from './images/merkle-science.png';
import metaEngine from './images/meta-engine.png';
import metalink from './images/metalink.png';
import metaplex from './images/metaplex.png';
import mojoverse from './images/mojoverse.png';
import monkeyball from './images/monkeyball.png';
import moonray from './images/moonray.png';
import mSQLogoLong from './images/msq-logo-long.svg';
import multicoin from './images/multicoin.png';
import nanotronics from './images/nanotronics.png';
import near from './images/near.png';
import nestedfinance from './images/nestedfinance.png';
import nibiru from './images/nibiru.png';
import noRamp from './images/no-ramp.png';
import noble from './images/noble.png';
import oasys from './images/oasys.png';
import obscuroLogo from './images/obscuro-logo.png';
import oPGames from './images/op-games.png';
import op3nBlack from './images/op3n-black.png';
import ordermark from './images/ordermark.png';
import orthogonal from './images/orthogonal.png';
import passport from './images/passport.png';
import pentagonGamesLogo from './images/pentagon-games.png';
import petraLogo from './images/petra-logo.svg';
import philo from './images/philo.png';
import pipe from './images/pipe.png';
import plaid from './images/plaid.png';
import planetMogoLogo from './images/planet-mogo-logo.png';
import pods from './images/pods.png';
import pokt from './images/pokt.png';
import polygon from './images/polygon.png';
import pontemNetworkLogo from './images/pontem-network-logo.png';
import portalDeFi from './images/portal-de-fi.png';
import prepo from './images/prepo.png';
import privateer from './images/privateer.png';
import proofofLearnLogo from './images/proofof-learn-logo.png';
import publicLogo from './images/public.png';
import pyth from './images/pyth.png';
import rainDrop from './images/rain-drop.png';
import rappi from './images/rappi.png';
import rARIBLE from './images/rarible.png';
import ratioFinance from './images/ratio-finance.png';
import relativity from './images/relativity.png';
import rescale from './images/rescale.png';
import revelatorLogo from './images/revelator-logo.png';
import rikkei from './images/rikkei.png';
import robinhood from './images/robinhood.png';
import saber from './images/saber.png';
import school16 from './images/school-16.png';
import seriesFi from './images/series-fi.png';
import shiprocket from './images/shiprocket.png';
import skyryse from './images/skyryse.png';
import sMBX from './images/smbx.png';
import snailtrail from './images/snailtrail.png';
import spacePerspectiveLogo from './images/space-perspective.png';
import spacex from './images/spacex.png';
import squads from './images/squads.png';
import staked from './images/staked.png';
import starAtlas from './images/star-atlas.png';
import steerLogo from './images/steer-logo.png';
import subspace from './images/subspace.png';
import superpedestrian from './images/superpedestrian.png';
import supraOracles from './images/supra-oracles.png';
import swing from './images/swing.png';
import symbiosis from './images/symbiosis.png';
import tailwindAcquisition from './images/tailwind-acquisition.png';
import tailwindInternational from './images/tailwind-international.png';
import terra from './images/terra.png';
import theTie from './images/the-tie.png';
import tradingStrategy from './images/trading-strategy.png';
import truefinLogo from './images/truefin-logo.png';
import turing from './images/turing.png';
import ubet from './images/ubet.png';
import ufit from './images/ufit.png';
import utila from './images/utila.png';
import versus from './images/versus.png';
import yorSpace from './images/york-space-system.png';
import zebecProtocol from './images/zebec-protocol.png';
import zedrunLogo from './images/zedrun-logo.png';
import zkLink from './images/zk-link.png';
import zoeLogo from './images/zoe-logo.png';

export const COMPANY_FOCUS_AREAS = ['Deep Tech', 'Web3', 'FinTech', 'Other'];

export const PORTFOLIO_FILTERS = ['Featured'];

export type FocusArea = typeof COMPANY_FOCUS_AREAS[number];

export interface IPortfolioCompany {
  name: string;
  logo: string | null;
  href?: string;
  description?: string;
  hide?: boolean;
  featured?: boolean;
  focusArea?: FocusArea;
}

export const getAlphaSortedCompanies = (): IPortfolioCompany[] =>
  PORTFOLIO_COMPANIES.filter((company) => !company.hide).sort((a, b) =>
    a.name.localeCompare(b.name)
  );

export const PORTFOLIO_COMPANIES: IPortfolioCompany[] = [
  {
    name: '1Inch',
    logo: oneInch,
    description:
      'is a DEX aggregator and a decentralized exchange with smart routing that connects a large number of platforms in order to minimize price slippage and find the optimal trade for its users. ',
    focusArea: 'Web3',
    href: 'https://1inch.io/',
  },
  {
    name: 'Acala',
    logo: acalaNetwork,
    description:
      "is a decentralized finance network powering the aUSD stablecoin ecosystem. It is a layer-1 smart contract platform that's scalable, Ethereum-compatible, and optimized for DeFi.",
    focusArea: 'Web3',
    href: 'https://acala.network/',
  },
  {
    name: 'Accredible',
    logo: accredible,
    description:
      'is a full service digital credential solution that allows companies to issue, verify, and track digital certifications.',
    focusArea: 'Other',
    href: 'https://www.accredible.com/',
  },
  {
    name: 'Agnetix',
    logo: agnetix,
    description:
      'is an electronics manufacturer that designs liquid cooling LED lights using the latest technology and science for indoor agriculture.',
    focusArea: 'Deep Tech',
    href: 'https://agnetix.com/',
  },
  {
    name: "Akin's Army",
    logo: aARMY,
    description:
      'is a fitness company that provides cardio and athlete training for people looking to improve their fitness through instructor-led classes.',
    focusArea: 'Other',
    href: 'https://www.aarmy.com/home',
  },
  {
    name: 'Albedo Space',
    logo: albedo,
    description:
      'is the next generation of earth observation and highest resolution satellite imagery commercially available.',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://albedo.com/',
  },
  {
    name: 'Amulet',
    logo: amulet,
    description:
      'is a decentralized, on-chain insurance protocol for blockchain protocols, starting with Solana',
    focusArea: 'Web3',
    href: 'https://amulet.org/',
  },
  {
    name: 'Hedron',
    logo: hedron,
    description:
      '(now called "Hedron") is a technology company that is building an in-orbit communication infrastructure that will enable real time knowledge of what is happening on the surface of our planet.',
    focusArea: 'Deep Tech',
    href: 'https://www.hedron.space/',
  },
  {
    name: 'Apollo Neuroscience',
    logo: apolloneuro,
    description:
      'is a technology company that creates wearable devices with low frequency vibrations meant to ease anxiety, stress, and improve focus.',
    focusArea: 'Other',
    href: 'https://apolloneuro.com/',
  },
  {
    name: 'Arbol',
    logo: arbol,
    description:
      'is an InsurTech platform for parametric products that pay quickly and fairly covering external risks such as unexpected weather.',
    focusArea: 'Deep Tech',
    href: 'https://www.arbolmarket.com/',
  },
  {
    name: 'Arcana',
    logo: arcana,
    description:
      'is a decentralized storage layer for Ethereum and EVM blockchains with a privacy stack for Auth, IAM, and KMS.',
    focusArea: 'Web3',
    href: 'https://arcana.network/',
  },
  {
    name: 'Array Labs',
    logo: arrayLabsLogo,
    href: 'https://www.arraylabs.io/',
    description:
      'is an aerospace company that produces high quality 3D satellite imagery',
    featured: true,
    focusArea: 'Deep Tech',
  },
  {
    name: 'Astaria',
    logo: astariaLogo,
    description:
      'is a highly functional on-chain lending protocol that enables instant liquid NFT lending',
    focusArea: 'Web3',
    href: 'https://astaria.xyz/',
  },
  {
    name: 'Astra',
    logo: astra,
    description:
      "is a decentralized compliance solution for the crypto space. With the help of Astra, protocols can comply with society's numerous regulations without giving up decentralization or putting investors at risk.",
    focusArea: 'Web3',
    href: 'https://astraprotocol.com/',
  },
  {
    name: 'Hop Protocol',
    logo: hop,
    description: 'Send your tokens across Ethereum scaling solutions.',
    focusArea: 'Web3',
    href: 'https://hop.exchange/',
  },
  {
    name: 'Avalanche',
    logo: avalanche,
    href: 'https://www.avax.network/',
    description:
      'is a proof of stake, smart contracts platform that boasts the fastest transaction speeds in the blockchain industry.',
    featured: true,
    focusArea: 'Web3',
  },
  {
    name: 'Axiom Space',
    logo: axiomSpace,
    description:
      "is building and operating Axiom Station, the world's first private space station. The company also completed the first private astronaut mission to the ISS.",
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://www.axiomspace.com/',
  },
  {
    name: 'B&J Studios',
    logo: bjStudios,
    description:
      'is a venture studio developing world class blockchain solutions for institutional grade problems',
    focusArea: 'Web3',
  },
  {
    name: 'Begin',
    logo: begin,
    description:
      'is a creator of engaging and effective learning products to bring children the highest quality education.',
    focusArea: 'Other',
    href: 'https://beginlearning.co/',
  },
  {
    name: 'BidsNFT',
    logo: bidNFTLogo,
    href: 'https://www.bidshop.io/',
    description:
      'is a decentralized reverse auction NFT marketplace that provides a gamified experience for users',
    focusArea: 'Web3',
  },
  {
    name: 'Bit.Country',
    logo: bitcountry,
    description:
      'is a project aimed at allowing anyone to start their own metaverse for their fans with NFTs.',
    focusArea: 'Web3',
    href: 'https://bit.country/',
  },
  {
    name: 'Blinkmoon',
    logo: blinkmoon,
    description:
      'is a new independent blockchain based game development studio',
    focusArea: 'Web3',
    href: 'https://blinkmoon.com/',
  },
  {
    name: 'Blockdaemon',
    logo: blockdaemon,
    description:
      'is an independent blockchain infrastructure platform enabling participants to stake, scale, and deploy nodes with institutional-grade security and monitoring. ',
    focusArea: 'Web3',
    href: 'https://blockdaemon.com/',
  },
  {
    name: 'BlockFi',
    logo: blockFi,
    description:
      'is a cryptocurrency lender that services clients worldwide and in all U.S. states, with USD loans backed by crypto, interest earning accounts, and trading. ',
    focusArea: 'Web3',
    href: 'https://blockfi.com/',
    hide: true,
  },
  {
    name: 'Blocklords',
    logo: blocklords,
    description: 'is a medieval metaverse game built by gamers, for gamers',
    focusArea: 'Web3',
    href: 'https://www.blocklords.com/#landing',
  },
  {
    name: 'BlockSwap',
    logo: blockswap,
    description:
      'is developing a suite of tools for multichain composable ETH to let people use their crypto on any blockchain without a bridge.',
    focusArea: 'Web3',
    href: 'https://www.blockswap.network/',
  },
  {
    name: 'Bokksu',
    logo: bokksu,
    description:
      'is a subscription box and e-commerce platform for Japanese snacks, candies, and teas. ',
    focusArea: 'Other',
    href: 'https://www.bokksu.com/',
  },
  {
    name: 'Botkeeper',
    logo: botkeeper,
    description:
      'is a software company that automates bookkeeping support to accounting firms through machine learning, artificial intelligence, and skilled accountants. ',
    focusArea: 'FinTech',
    href: 'https://www.botkeeper.com/',
  },
  {
    name: 'Busha',
    logo: bushaLogo,
    description:
      "is Africa's leading digital asset platform powering buy, sell, and trading functions for cryptocurrency",
    focusArea: 'Web3',
    href: 'https://www.busha.co/',
  },
  {
    name: 'Campground ',
    logo: campground,
    description:
      'is a Web 3 social marketplace pioneering the next era of internet exploration, backed by NEAR Protocol.',
    focusArea: 'Web3',
    href: 'https://www.campground.co/',
  },
  {
    name: 'Caraway',
    logo: caraway,
    description:
      'is a direct-to-consumer cookware manufacturer that crafts eco-friendly, non-toxic, ceramic kitchen goods.',
    focusArea: 'Other',
    href: 'https://www.carawayhome.com/',
  },
  {
    name: 'Carta',
    logo: cartaLogo,
    description:
      'is an ownership and equity management platform that helps companies and investors manage their cap tables, valuations, investments, and equity plans.',
    focusArea: 'FinTech',
    href: 'https://carta.com/',
  },
  {
    name: 'Cere',
    logo: cereNetwork,
    description:
      'is a decentralized data cloud platform that delivers data integration and data collaboration solutions.',
    focusArea: 'Web3',
    href: 'https://cere.network/',
  },
  {
    name: 'Chingari',
    logo: chingari,
    href: 'https://chingari.io/',
    description:
      'is an Indian short-form video entertainment platform that allows users to post video clips, watch movies, listen to music, and shop online.',
    focusArea: 'Web3',
  },
  {
    name: 'Claystack',
    logo: claystack,
    description:
      'is a decentralized liquid staking platform that enables users to unlock the liquidity of staked assets across multiple chains. ',
    focusArea: 'Web3',
    href: 'https://claystack.com/',
  },
  {
    name: 'CoinDCX',
    logo: coinDCX,
    description:
      "is India's leading cryptocurrency app powering an array of investment products",
    focusArea: 'Web3',
    href: 'https://coindcx.com/',
  },
  {
    name: 'CoinFund',
    logo: coinfund,
    description:
      'partners with the creators behind the digital assets, key enabling infrastructure, and decentralization technologies shaping the future of blockchain.',
    focusArea: 'Web3',
    href: 'https://www.coinfund.io/',
  },
  {
    name: 'Comm.app',
    logo: commAppLogo,
    href: 'https://comm.app/',
    description: 'is a crypto native messaging tool for web3 projects',
    focusArea: 'Web3',
  },
  {
    name: 'Customer.io',
    logo: customerIo,
    description:
      'is an automated messaging platform that gives marketers more control and flexibility to craft and send data-driven emails, push notifications, and SMS messages.',
    focusArea: 'Other',
    href: 'https://customer.io/',
  },
  {
    name: 'Dapix',
    logo: dapix,
    description:
      'is a blockchain technology company that aims to revolutionize inter-wallet operability with the FIO Protocol. ',
    focusArea: 'Web3',
    href: 'https://fioprotocol.io/',
  },
  {
    name: 'Dapper Labs',
    logo: dapper,
    description:
      'is a blockchain-based gaming platform that brought the benefits of decentralization to the first billion consumers through the power of play, fairness and true ownership.',
    focusArea: 'Web3',
    href: 'https://www.dapperlabs.com/',
  },
  {
    name: 'dClimate',
    logo: dClimate,
    description:
      'is a transparent, decentralized climate data marketplace and DAO that allows participants to buy and share data.',
    focusArea: 'Deep Tech',
    href: 'https://www.dclimate.net/',
  },
  {
    name: 'Deesse',
    logo: deesse,
    description:
      'is a blockchain enabled, idle Role-Playing Game (RPG) or Card Placement Game (CPG) with progress-based and skill-based features and incorporating play-to-earn mechanic.',
    focusArea: 'Web3',
    href: 'https://deesse.art/home',
  },
  {
    name: 'Dexalot',
    logo: dexalot,
    description:
      'is a revolutionary decentralized exchange aiming at bringing the traditional centralized exchange look and feel through a decentralized on-chain application.',
    focusArea: 'Web3',
    href: 'https://dexalot.com/',
  },
  {
    name: 'Dodoex',
    logo: dodoex,
    description:
      'is an ARK taming calculator app for action-adventure survival video game ARK: Survival Evolved (PC, Xbox, PS4).',
    focusArea: 'Web3',
    href: 'https://dodoex.io/',
  },
  {
    name: 'Double Jump',
    logo: doublejumpLogo,
    href: 'https://www.doublejump.tokyo/en',
    description:
      'is a blockchain-based game development studio focused on NFT solutions',
    focusArea: 'Web3',
  },
  {
    name: 'DrinkBev',
    logo: bev,
    description:
      'is a 100% female-led beverage company that offers various wine flavors in a can.',
    focusArea: 'Other',
    href: 'https://drinkbev.com/',
  },
  {
    name: 'DuraFi (Lolliswap)',
    logo: duraFi,
    description:
      'is a decentralized exchange bringing Wall Street quality derivatives and asset management in a gamified experience.',
    focusArea: 'Web3',
    href: 'https://dura.fi/',
  },
  {
    name: 'Earth AI',
    logo: earth,
    description: 'is a vertically integrated metals exploration company',
    focusArea: 'Web3',
    href: 'https://earth.net/',
  },
  {
    name: 'Element Finance',
    logo: elementFinance,
    description:
      'is an open source protocol for fixed and variable yield markets.',
    focusArea: 'Web3',
    href: 'https://www.element.fi/',
  },
  {
    name: 'EquipmentShare',
    logo: equipmentShareColored,
    description:
      'is an equipment and digital solutions provider that helps thousands of contractors access tech and equipment to maximize productivity.',
    focusArea: 'Other',
    href: 'https://www.equipmentshare.com/',
  },
  {
    name: 'Fandom',
    logo: fandom,
    description:
      'is a new way for creators to create short form video content through NFTs',
    focusArea: 'Web3',
    href: 'https://fandom.co/',
  },
  {
    name: 'Fareplay',
    logo: farePlay,
    description: 'is a decentralized casino built on Avalanche',
    focusArea: 'Web3',
    href: 'https://fareprotocol.io/',
  },
  {
    name: 'Firefly',
    logo: fireflyAerospace,
    description:
      'is a provider of economical and dependable launch vehicles, spacecraft, and in-space services for small payloads.',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://fireflyspace.com/',
  },
  {
    name: 'Flipside Crypto',
    logo: flipside,
    description:
      'is bounty data analytics platform for curated onchain metrics',
    focusArea: 'Web3',
    href: 'https://flipsidecrypto.xyz/',
  },
  {
    name: 'FOMO Pay',
    logo: fomoPayLogo,
    href: 'www.fomopay.com',
    description:
      'is an all-in-on suite of financial infrastructure products enabling on/off ramps for institutional clients',
    focusArea: 'Web3',
  },
  {
    name: 'Fonbnk',
    logo: fonbnk,
    description:
      'is a distributed finance company enabling a frictionless, financial on-ramp for emerging markets. Leveraging the existing network of mobile phone accounts, anyone with a prepaid mobile SIM card can now have access to the global digital economy.',
    focusArea: 'FinTech',
    href: 'https://www.fonbnk.com/',
  },
  {
    name: 'FreshCut Labs',
    logo: freshCutLabs,
    description:
      'Freshcut is a short-form video platform targeted directly at gamers; with the goal of solving short form discovery and monetization, Freshcut’s platform will connect gaming streamers directly with fans via tokenized economics that permit all parties to profit from the communal efforts.',
    focusArea: 'Web3',
    href: 'https://freshcut.gg/',
  },
  {
    name: 'Galaxy Eco',
    logo: galaxyEco,
    href: 'https://galaxy.eco/',
    description:
      'is an open, decentralized credential data network building permisonless infrastructure that powers on-chain credentials through NFT-as-a-service plug-and-play modules and provides credential data for blockchain protocols.',
    focusArea: 'Web3',
  },
  {
    name: 'GamerGains',
    logo: gamerGains,
    description:
      'is a wrapper for Steam games that permits anyone with a Steam account to set up a P2E challenge on top of any game of their choosing.',
    focusArea: 'Web3',
    href: 'https://gamergains.com/',
  },
  {
    name: 'Genies',
    logo: genies,
    description:
      'Genies is an avatar technology company that allows users to virtually clone themselves. ',
    focusArea: 'Web3',
    href: 'https://genies.com/',
  },
  {
    name: 'GMI Computing',
    logo: gMIComputing,
    description:
      'is a digital asset infrastructure company providing high-speed node service to blockchain applications',
    focusArea: 'Web3',
    href: 'https://gmicomputing.io/',
  },
  {
    name: 'Gnosis',
    logo: gnosisLogo,
    description:
      'is a builder of new market mechanisms for decentralized finance. ',
    focusArea: 'FinTech',
    href: 'https://gnosis.io/',
  },
  {
    name: 'Gogopool',
    logo: goGoPool,
    description:
      'is a liquid staking platform providing tools to build the Avalanche subnet economy',
    focusArea: 'Web3',
    href: 'https://www.gogopool.com/',
  },
  {
    name: 'Golden Hearts Gaming',
    logo: goldenHearts,
    description:
      'is an online gaming company that creates and offers digital Charitable Promotional Games.',
    focusArea: 'Other',
    href: 'https://goldenheartsgames.com/',
  },
  {
    name: 'Good Eggs',
    logo: goodeggs,
    description:
      'is an online grocer and meal kit delivery service that offers peak-quality food that’s local, organic, and sourced with integrity.',
    focusArea: 'Other',
    href: 'https://www.goodeggs.com/home',
  },
  {
    name: 'goTenna',
    logo: goTenna,
    description:
      'is a communication device company that designs and develops technologies for off-grid and decentralized communications.',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://gotenna.com/',
  },
  {
    name: 'Gunzilla',
    logo: gunzilla,
    description:
      'is a triple A game development company developing "Off the Grid",  a cyberpunk battle royale (PVP/Coop PvE) game for all platforms (PC/PS5/Xbox/Mobile) built using the Unreal 5 engine.',
    focusArea: 'Web3',
    featured: true,
    href: 'https://gunzillagames.com/en/',
  },
  {
    name: 'Hedgehog',
    logo: hedgehog,
    description:
      'is a portfolio manager and trading application for cryptocurrencies.',
    focusArea: 'Web3',
    href: 'https://hedgehog.markets/',
  },
  {
    name: 'Hike',
    logo: hike,
    description:
      'is the studio behind Rush App, a mini-game platform that showcases games of skill blended with an avatar identity and social media elements.',
    focusArea: 'Web3',
    href: 'https://www.getrushapp.com/',
  },
  {
    name: 'Hubble',
    logo: hubble,
    description:
      'is a DeFi protocol built on Solana that allows users to deposit multiple assets to mint USDH at attractive LTVs.',
    focusArea: 'Web3',
    href: 'https://hubbleprotocol.io/',
  },
  {
    name: 'Humanode',
    logo: humanode,
    description:
      'is a network based on private biometrically encrypted nodes (or replicas)',
    focusArea: 'Web3',
    href: 'https://humanode.io/',
  },
  {
    name: 'Incept Protocol',
    logo: incept,
    description:
      'is a capital efficient, synthetic asset protocol built on Solana',
    focusArea: 'Web3',
    href: 'https://www.incept.so/',
  },
  {
    name: 'Ink Finance',
    logo: inkFinanceLogo,
    href: 'https://inkfinance.xyz/',
    description:
      'is an all-in-one DAO toolset and developer tooling application',
    focusArea: 'Web3',
  },
  {
    name: 'IQ Protocol',
    logo: iqprotocol,
    description:
      'is a DeFi framework for renting wrapped expirable versions of digital assets, such as NFTs, for the use cases they empower.',
    focusArea: 'Web3',
    href: 'https://iq.space/',
  },
  {
    name: 'Jet Protocol',
    logo: jetProtocol,
    description:
      'is a decentralized borrowing and lending protocol built for speed, power, and scalability on Solana.',
    focusArea: 'Web3',
    href: 'https://www.jetprotocol.io/',
  },
  {
    name: 'Jetty',
    logo: jetty,
    description:
      'is a financial services platform designed to improve the financial lives of renters and their property managers.',
    focusArea: 'FinTech',
    href: 'https://www.jetty.com/',
  },
  {
    name: 'JUUL',
    logo: juul,
    description:
      'is an electronic cigarette company that makes single-use nicotine cartridges.',
    focusArea: 'Other',
    href: 'https://www.juul.com/',
    hide: true,
  },
  {
    name: 'Kado Money',
    logo: kado,
    description:
      'is building the one-stop shop on Terra for living in crypto. Its on- and off-ramps allows users to buy, pay with, and save with their UST stablecoins.',
    focusArea: 'Web3',
    href: 'https://www.kado.money/',
  },
  {
    name: 'Kafene',
    logo: kafene,
    description:
      'is a fintech company that brings flexible payment options to products like furniture, appliances, electronics, musical instruments, and jewelry.',
    focusArea: 'FinTech',
    href: 'https://kafene.com/',
  },
  {
    name: 'Kibo',
    logo: kibo,
    description:
      'is the first decentralized lottery platform based on Ethereum smart-contracts.',
    focusArea: 'Web3',
    href: 'https://kibo.finance/',
  },
  {
    name: 'Klarna',
    logo: klarna,
    description:
      'is an online payment processing provider that partners with global retailers to elevate the entire shopping experience.',
    focusArea: 'FinTech',
    href: 'https://www.klarna.com/us/',
  },
  {
    name: 'Kraken',
    logo: kraken,
    description:
      'is a cryptocurrency exchange and bank. The exchange provides trading between cryptocurrency and fiat currencies.',
    focusArea: 'Web3',
    href: 'https://www.kraken.com/en-us/',
  },
  {
    name: 'Lora DiCarlo',
    logo: loraDiCarlo,
    description:
      'is a sex tech brand that is known for engineering pleasure tech products.',
    focusArea: 'Other',
    href: 'https://loradicarlo.com/',
  },
  {
    name: 'LoverBoy',
    logo: loverboy,
    description:
      'is a gluten-free canned alcoholic beverage made from organic brewed tea.',
    focusArea: 'Other',
    href: 'https://drinkloverboy.com/',
  },
  {
    name: 'LTSE',
    logo: ltse,
    description:
      'is a capital market exchange that offers software and services for modern companies that are pursuing a path to the public markets and beyond.',
    focusArea: 'FinTech',
    href: 'https://ltse.com/',
  },
  {
    name: 'Lucid Sight',
    logo: lucidsight,
    description:
      'is developing technologies to support the evolving gaming landscape. To date, the company has built over two dozen games, apps, and experiences using its cutting-edge multiplayer tech stack.',
    focusArea: 'Web3',
    href: 'https://www.lucidsight.com/',
  },
  {
    name: 'Magic Square ',
    logo: mSQLogoLong,
    description:
      'is a web3 app store that simplifies access to crypto applications',
    focusArea: 'Web3',
    href: 'https://magicsquare.io/',
  },
  {
    name: 'Magpie',
    logo: magpieLogo,
    description:
      'is a decentralized token bridge enabling swaps between chains',
    focusArea: 'Web3',
    href: 'https://www.magpiefi.xyz/',
  },
  {
    name: 'Merkle Sceince ',
    logo: merkleScience,
    description:
      'is a transaction monitoring, compliance, and investigations software focused on threat intelligence',
    focusArea: 'Web3',
    href: 'https://www.merklescience.com/',
  },
  {
    name: 'MetaEngine',
    logo: metaEngine,
    description:
      'is an all-in-one platform that incorporates a professional-grade game engine and blockchain integrations',
    focusArea: 'Web3',
    href: 'https://metaengine.gg/',
  },
  {
    name: 'Metalink',
    logo: metalink,
    description:
      'is a community based online social and messaging platform that grants access to users based on certain criteria, like owning a crypto punk, and gives communities a dedicated place to connect. ',
    focusArea: 'Web3',
    href: 'https://metalink.com/',
  },
  {
    name: 'Metaplex',
    logo: metaplex,
    description:
      'is a collection of crypto tools and smart contracts aimed to make the process of creating and launching NFTs easier.',
    focusArea: 'Web3',
    href: 'https://www.metaplex.com/',
  },
  {
    name: 'Mojoverse',
    logo: mojoverse,
    description:
      'is building out a suite of blockchain-based games built on the Unity game engine. Mojo Melee is the opening game in Mojoverse and hosts a PvP auto-chess battler game centered around play-to-earn mechanics and an NFT marketplace.',
    focusArea: 'Web3',
    href: 'https://happygiant.com/',
  },
  {
    name: 'Monkeyball',
    logo: monkeyball,
    description:
      'is a next-gen esports metaverse that enables players to create, play, compete, and earn rewards.',
    focusArea: 'Web3',
    href: 'https://www.monkeyleague.io/',
  },
  {
    name: 'Moonray',
    logo: moonray,
    description:
      'is a next-generation blockchain based multiplayer action combat game',
    focusArea: 'Web3',
    href: 'https://www.moonray.game/',
  },
  {
    name: 'MotoRefi',
    logo: caribou,
    description:
      '(now called "Caribou") is a mission-based FinTech startup that uses technology to help car owners save money and time.',
    focusArea: 'FinTech',
    href: 'https://www.caribou.com/',
  },
  {
    name: 'Multicoin',
    logo: multicoin,
    description:
      'is a thesis-driven investment firm that invests in cryptocurrencies, tokens, and blockchain companies reshaping trillion-dollar markets.',
    focusArea: 'Web3',
    href: 'https://multicoin.capital/',
  },
  {
    name: 'Nanotronics',
    logo: nanotronics,
    description:
      'is a nontechnology company that builds hardware and software that can be used to see features down to the nanometer scale.',
    focusArea: 'Deep Tech',
    href: 'https://nanotronics.co/',
  },
  {
    name: 'NEAR Protocol',
    logo: near,
    description:
      'is a sharded, layer-1 blockchain protocol that was designed to be a developer-friendly smart contract platform for high performance and scalable decentralized applications.',
    focusArea: 'Web3',
    href: 'https://near.org/',
  },
  {
    name: 'Nested Finance',
    logo: nestedfinance,
    description:
      'is a one-stop DeFi platform to build, manage, and monetize personal portfolios. Nested enables users to create Nested portfolios by nesting tokens (up-to-twelve) together into a unique NFT.',
    focusArea: 'Web3',
    href: 'https://nested.fi/',
  },
  {
    name: 'Nibiru',
    logo: nibiru,
    description:
      'is a proof-of-stake blockchain built on the Cosmos IBC. Nibiru is a decentralized platform that unifies leveraged derivatives trading, spot trading, staking, and bonded liquidity provisions into a seamless user experience.',
    focusArea: 'Web3',
    href: 'https://nibiru.fi/',
  },
  {
    name: 'Noble',
    logo: noble,
    description:
      'is a mobile application that allows people to order, pay, and tip for concessions right from their phone at event venues without having to wait in line.',
    focusArea: 'Other',
    href: 'http://www.getnoble.co/',
  },
  {
    name: 'NotVC',
    logo: null,
    description: 'is a venture capital fund focused on frontier technologies',
    focusArea: 'Deep Tech',
    href: '',
  },
  {
    name: 'Oasys',
    logo: oasys,
    description: 'is a EVM-compatible L2 focused on blockchain based games',
    focusArea: 'Web3',
    href: 'https://www.oasys.games/',
  },
  {
    name: 'Obscuro',
    logo: obscuroLogo,
    href: 'https://obscu.ro/',
    description: 'is an application specific L2 protocol built for privacy',
    focusArea: 'Web3',
  },
  {
    name: 'OP Games',
    logo: oPGames,
    description:
      'is a developer and manufacturer of board games and puzzles, including brands like Harry Potter, Clue, and Trvial Pursuit.',
    focusArea: 'Web3',
    href: 'https://www.opgames.org/',
  },
  {
    name: 'Op3n Studios ',
    logo: op3nBlack,
    href: 'https://op3n.world/',
    description:
      'is a crypto application that boasts a vertically integrated NFT creation tool',
    focusArea: 'Web3',
  },
  {
    name: 'Ordermark',
    logo: ordermark,
    description:
      'is a restaurant technology service provider in the mobile online ordering space that helps restaurants increase efficiency and grow profits.',
    focusArea: 'FinTech',
    href: 'https://www.ordermark.com/',
  },
  {
    name: 'Orthogonal Thinker',
    logo: orthogonal,
    description:
      'is a biotech holding company that acquires and accelerates companies engaged in DEA registered psilocybin, psychoactive compounds, clean label foods, and plant sciences.',
    focusArea: 'Other',
    href: 'https://orthogonalthinker.com/',
  },
  {
    name: 'Passport',
    logo: passport,
    description:
      'is an end-to-end international shipping carrier, offering high touch customer support for accurate delivery dates and precise pickup locations.',
    focusArea: 'Other',
    href: 'https://passportshipping.com/',
  },
  {
    name: 'Pentagon Games',
    logo: pentagonGamesLogo,
    href: 'https://pentagon.games/',
    description:
      'Revolutionizing Game Publishing with AI-Driven Cross Reality Metaverses and Web3',
    focusArea: 'Web3',
    featured: false,
  },
  {
    name: 'Petra',
    logo: petraLogo,
    href: 'https://petra.cc/',
    description:
      'is a novel hard rock boring-robot company tackling the hardest problem in undergrounding & tunneling',
    focusArea: 'Deep Tech',
    featured: true,
  },
  {
    name: 'Philo',
    logo: philo,
    description:
      'is an American media platform that provides live streaming to major broadcast and cable channels, available on both smartphones and computers.',
    focusArea: 'Other',
    href: 'https://www.philo.com/',
  },
  {
    name: 'Pipe',
    logo: pipe,
    description:
      'is a global trading platform for recurring revenue streams, connecting companies to institutional investors to trade in real-time.',
    focusArea: 'FinTech',
    href: 'https://pipe.com/',
  },
  {
    name: 'Plaid',
    logo: plaid,
    description:
      'is a financial services company that builds a data transfer network that powers fintech and digital finance products.',
    focusArea: 'FinTech',
    href: 'https://plaid.com/',
  },
  {
    name: 'Planet Mojo',
    logo: planetMogoLogo,
    href: 'https://www.planetmojo.io/',
    description: 'is a blockchain enabled PvP game with embedded NFT economics',
    focusArea: 'Web3',
  },
  {
    name: 'Pocket Network',
    logo: pokt,
    description:
      'provides RPC access to Ethereum, Polygon, and a dozen more blockchain networks with everything from testnets to mainnets to any open-source interface.',
    focusArea: 'Web3',
    href: 'https://www.pokt.network/',
  },
  {
    name: 'Pods Finance ',
    logo: pods,
    description:
      'is a decentralized non-custodial options protocol where users can create options and trade them on the Ethereum Blockchain.',
    focusArea: 'Web3',
    href: 'https://www.pods.finance/',
  },
  {
    name: 'Polygon',
    logo: polygon,
    description:
      'is a protocol and a framework for building and connecting Ethereum-compatible blockchain networks.',
    focusArea: 'Web3',
    href: 'https://polygon.technology/',
  },
  {
    name: 'Pontem Network',
    logo: pontemNetworkLogo,
    href: 'https://pontem.network/',
    description: 'is the experimentation platform for Facebook backed "Diem"',
    focusArea: 'Web3',
  },
  {
    name: 'Portal Defi ',
    logo: portalDeFi,
    description:
      'is a defi platform that allows decentralized finance to become uncensorable, peer to peer, and trust minimized.',
    focusArea: 'Web3',
    href: 'https://portaldefi.com/',
  },
  {
    name: 'PrePO',
    logo: prepo,
    description:
      'is a decentralized trading platform allowing anyone, anywhere to gain exposure to any pre-public asset.',
    focusArea: 'Web3',
    href: 'https://prepo.io/',
  },
  {
    name: 'Privateer',
    logo: privateer,
    description:
      'is a data infrastructure company enabling sustainable growth for the new space economy',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://mission.privateer.com/',
  },
  {
    name: 'Proof of Learn',
    logo: proofofLearnLogo,
    description:
      'is the developer of an education platform that addresses the skills shortage experienced by the Web3 economy.',
    focusArea: 'Web3',
    href: 'https://www.proofoflearn.io/',
  },
  {
    name: 'Public',
    logo: publicLogo,
    description:
      'is an investing platform that empowers members to build a diverse portfolio of stocks, ETFs, and crypto.',
    focusArea: 'FinTech',
    href: 'https://public.com/',
  },
  {
    name: 'Pyth Network',
    logo: pyth,
    description:
      'is a specialized oracle solution for latency-sensitive financial data that delivers a decentralized, cross-chain market of verifiable data from high-quality nodes to any smart contract.',
    focusArea: 'Web3',
    href: 'https://pyth.network/',
  },
  {
    name: 'Rappi',
    logo: rappi,
    description:
      'is a Latin American consumer tech company that specializes in providing online delivery services. It connects consumers who want to purchase prepared foods, groceries, clothes, and virtually anything with independent contractors who can fulfill those needs.',
    focusArea: 'FinTech',
    href: 'https://www.rappi.com/',
  },
  {
    name: 'Rarible',
    logo: rARIBLE,
    description:
      'is an operator of a community-owned NFT marketplace that allows users to buy and auction off digital collectibles.',
    focusArea: 'Web3',
    href: 'https://rarible.com/',
  },
  {
    name: 'Ratio Finance',
    logo: ratioFinance,
    description:
      'is a collateralized debt position protocol on Solana, allowing depositors to make a high yield on their assets.',
    focusArea: 'Web3',
    href: 'https://ratio.finance/',
  },
  {
    name: 'Relativity Space',
    logo: relativity,
    description:
      'is an aerospace company that designs, develops, and builds 3D printed rockets.',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://www.relativityspace.com/',
  },
  {
    name: 'Rescale',
    logo: rescale,
    description:
      'is a cloud simulation platform that enables engineers and scientists to build, compute, analyze, and scale simulations with high performance computing. ',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://rescale.com/',
  },
  {
    name: 'Revelator',
    logo: revelatorLogo,
    href: 'https://www.revelator.com/',
    description: 's an on-chain liquidity protocol for music royalty payments',
    focusArea: 'Web3',
  },
  {
    name: 'Rikkei',
    logo: rikkei,
    description:
      'is a revolutionary decentralized protocol for lending and borrowing multiple assets on multi-chain.',
    focusArea: 'Web3',
    href: 'https://rikkei.finance/',
  },
  {
    name: 'Robinhood',
    logo: robinhood,
    description:
      'is a stock brokerage that allows customers to buy and sell stocks, options, ETFs, and cryptocurrencies.',
    focusArea: 'FinTech',
    href: 'https://robinhood.com/us/en/',
  },
  {
    name: 'Saber',
    logo: saber,
    description:
      'is a cross-chain AMM for pegged assets on Solana, helping facilitate the transfer of assets between Solana and other blockchains.',
    focusArea: 'Web3',
    href: 'https://app.saber.so/swap',
  },
  {
    name: 'School16',
    logo: school16,
    description:
      'is a provider of online classes, events, and educational programs for students to prepare for technical jobs.',
    focusArea: 'Other',
    href: 'https://www.school16.co/',
  },
  {
    name: 'SeriesFi',
    logo: seriesFi,
    description:
      'is a vertically integrated financial product offering for institutional clients',
    focusArea: 'FinTech',
    href: 'https://seriesfi.com/',
  },
  {
    name: 'Shiprocket',
    logo: shiprocket,
    description:
      "is India's only automated shipping solution for eCommerce, providing cost effective shipping for direct to consumer. ",
    focusArea: 'FinTech',
    href: 'https://www.shiprocket.in/',
  },
  {
    name: 'Skyryse',
    logo: skyryse,
    description:
      'is an air mobility company that develops hardware and software operating systems.',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://skyryse.com/',
  },
  {
    name: 'SMBX',
    logo: sMBX,
    description:
      'is a debt-focused financial services company that offers ways for small businesses to raise capital from their communities, and for everyday investors to grow their wealth.',
    focusArea: 'FinTech',
    href: 'https://www.thesmbx.com/',
  },
  {
    name: 'Snailtrail',
    logo: snailtrail,
    description:
      'is the first NFT based racing game on the Avalanche Network. In Snail Trails, each snail has 4 unique characteristics: Family, Class, Generation, and Adaptation.',
    focusArea: 'Web3',
    href: 'snailtrail.art',
  },
  {
    name: 'SpaceX',
    logo: spacex,
    description:
      'is an aviation and aerospace company that designs, manufactures, and launches advanced rockets and spacecraft.',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://www.spacex.com/',
  },
  {
    name: 'Squads',
    logo: squads,
    description:
      'is an application that can be used to create DAOs on the Solana blockchain',
    focusArea: 'Web3',
    href: 'https://squads.so/index.html',
  },
  {
    name: 'Staked',
    logo: staked,
    description:
      'is a non-custodial defi lending partner that helps investors earn yield from staking and DeFi.',
    focusArea: 'Web3',
    href: 'https://staked.us/',
  },
  {
    name: 'Star Atlas (ATLAS)',
    logo: starAtlas,
    description:
      'is a metaverse introducing a unique gaming experience by harnessing the power of traditional core game and blockchain mechanics.',
    focusArea: 'Web3',
    href: 'https://staratlas.com/',
  },
  {
    name: 'Star Atlas (POLIS)',
    logo: null,
    description:
      'is a blockchain-based, space-themed, grand strategy video game built on the Solana blockchain.',
    focusArea: 'Web3',
    href: 'https://staratlas.com/',
  },
  {
    name: 'Steer Protocol',
    logo: steerLogo,
    href: 'https://steer.finance/',
    description:
      'is a platform for cross-chain automated strategies with secure on-chain executions with minimal fees to users, providing maximal yield on earned fees for participating in the protocol.',
    focusArea: 'Web3',
  },
  {
    name: 'Subspace',
    logo: subspace,
    description:
      'is a dedicated internet provider for online multiplayer games.',
    focusArea: 'Other',
    href: 'https://subspace.network/',
  },
  {
    name: 'Superpedestrian',
    logo: superpedestrian,
    description:
      'is a transportation robotics company that develops lightweight electric vehicles with integrated online platforms.',
    focusArea: 'Deep Tech',
    href: 'https://superpedestrian.com/',
  },
  {
    name: 'Supra Oracles',
    logo: supraOracles,
    description:
      'is a blockchain network that uses real-time data on the financial markets for a secure interface & Defi smart contracts.',
    focusArea: 'Web3',
    href: 'https://supraoracles.com/',
  },
  {
    name: 'Swing (Polkaswitch)',
    logo: swing,
    description:
      'is a cross-chain crypto liquidity protocol that helps traders and yield farmers move crypto capital efficiently across blockchains.',
    focusArea: 'Web3',
    href: 'https://swing.xyz/',
  },
  {
    name: 'Symbiosis',
    logo: symbiosis,
    description:
      'is an aggregator of decentralized exchange liquidity across any EVM and non-EVM networks allowing users to swap any token and transfer liquidity.',
    focusArea: 'Web3',
    href: 'https://symbiosis.finance/',
  },
  {
    name: 'Tailwind International Sponsor LLC',
    logo: tailwindInternational,
    description:
      'is a blank check company formed for the purpose of effecting a merger, capital stock exchange, asset acquisition, stock purchase, reorganization or similar business combination with one or more businesses.',
    focusArea: 'Other',
    href: 'https://www.tailwindacquisition.com/',
  },
  {
    name: 'Tailwind Sponsor LLC (to merge with "NUBURU")',
    logo: tailwindAcquisition,
    description:
      'merged with NUBURU, a leading innovator in high power and high brightness industrial blue laser technology that addresses a broad range of high value applications.',
    focusArea: 'Other',
    href: 'https://www.tailwindacquisition.com/',
  },
  {
    name: 'Tempo Games (Avy Entertainment)',
    logo: null,
    description:
      'is a world-class producer of video games, interactive TV shows and movies,  worldwide tournaments and events, and more.',
    focusArea: 'Other',
    href: '',
  },
  {
    name: 'Terra',
    logo: terra,
    description:
      'is the leader in decentralized stablecoins. Terra’s largest stablecoin, $UST, has a market cap of nearly $20B and is one of the largest cryptocurrencies by market capitalization.',
    focusArea: 'Web3',
    href: 'https://www.terra.money/',
    hide: true,
  },
  {
    name: 'The Tie',
    logo: theTie,
    description:
      'is the leading provider of information services for digital assets. Its core offering, the Crypto SigDev Terminal, is the fastest and most comprehensive workstation for institutional digital asset investors.',
    focusArea: 'Web3',
    href: 'https://www.thetie.io/',
  },
  {
    name: 'Trading Strategies',
    logo: tradingStrategy,
    description:
      'is the next generation algorithmic trading protocol for decentralized markets.',
    focusArea: 'Web3',
    href: 'https://tradingstrategy.ai/',
  },
  {
    name: 'Truefin',
    logo: truefinLogo,
    href: 'https://truefi.io/',
    description:
      'is a decentralized protocol for structured financial products and options',
    focusArea: 'Web3',
  },
  {
    name: 'Turing',
    logo: turing,
    description:
      'is an information technology company that enables start-ups, businesses, and organizations to hire software engineers.',
    focusArea: 'Other',
    href: 'https://www.turing.com/',
  },
  {
    name: 'Ubet',
    logo: ubet,
    description:
      "is a developer of a mobile application for betting. The company's offerings include racing, sports, summer racing and live betting.",
    focusArea: 'Other',
    href: 'https://www.ubetsports.io/',
  },
  {
    name: 'Ufit',
    logo: ufit,
    description:
      'is a DAO-governed platform for general-purpose securitization of tokenized (and tokenizable) assets. It is asset-agnostic in the sense that it builds a mechanism for securitization that operates on asset-wraps rather than the asset itself.',
    focusArea: 'Web3',
    href: '',
  },
  {
    name: 'Utilia',
    logo: utila,
    description:
      'is building a digital asset infrastructure that will enable a secure, instant, and efficient participation in crypto for developers, teams, and enterprises',
    focusArea: 'Web3',
    href: 'https://utila.io/',
  },
  {
    name: 'VCVC SPAC',
    logo: tenXCapital,
    description:
      'is a blank-check company that effects mergers, share exchanges, asset acquisitions, share purchases, and reorganizations.',
    focusArea: 'Other',
    href: 'https://www.10xcapital.com/',
  },
  {
    name: 'Versus',
    logo: versus,
    description:
      'is a mobile platform that empowers individuals to earn money through categories they are experts about, through their own ingenuity, on an evolving array of topics.',
    focusArea: 'Other',
    href: 'https://versusgame.com/app/game',
  },
  {
    name: 'Zed Run',
    logo: zedrunLogo,
    href: 'https://zed.run/',
    description: 'is a NFT digital horse racing game built on Polygon',
    focusArea: 'Web3',
  },
  {
    name: 'Zebec Protocol',
    logo: zebecProtocol,
    description:
      'is a continuous settlement protocol on Solana, enabling the composable transfer of value.',
    focusArea: 'Web3',
    href: 'https://zebec.io/',
  },
  {
    name: 'zk.Link',
    logo: zkLink,
    description:
      'is a cross-chain decentralized exchange that utilizes zero-knowledge rollups (zk-rollups) technology.',
    focusArea: 'Web3',
    href: 'https://test.zk.link/',
  },
  {
    name: 'Zoe Financial',
    logo: zoeLogo,
    description:
      'is a fintech company that helps its customers find an independent and fiduciary financial advisor. ',
    focusArea: 'FinTech',
    href: 'https://zoefin.com/',
  },
  {
    name: 'NoRamp',
    logo: noRamp,
    description:
      'Noramp is a crypto onramp enabling on-chain decentralized digital asset transfer',
    focusArea: 'Web3',
    href: 'https://www.noramp.io/',
  },
  {
    name: 'Cupcake',
    logo: cupCake,
    description:
      'Cupcake is a NFT super app that simplifies the complex technical restrictions and lengthy setup processes typical of acquiring NFTs.',
    focusArea: 'Web3',
    href: 'https://cupcake.com/',
  },
  {
    name: 'Raindrop',
    logo: rainDrop,
    description:
      'Raindrops is a decentralized protocol built to allow interchangeable NFTs within any game',
    focusArea: 'Web3',
    href: 'https://www.raindrops.xyz/',
  },
  {
    name: 'York Space Systems',
    logo: yorSpace,
    description:
      'York Space Systems is an independent provider of high-performance / low-cost small satellites, satellite components, and turnkey mission operations, trusted by top government agencies and commercial customers.',
    focusArea: 'Deep Tech',
    featured: true,
    href: 'https://www.yorkspacesystems.com/',
  },
  {
    name: 'K2 Space',
    logo: k2,
    description:
      'K2 Space uses the full capacity of launch vehicles like F9 and Starship to break the correlation between spacecraft mass and cost.',
    focusArea: 'Deep Tech',
    featured: true,
    href: ' https://www.k2space.com/',
  },
  {
    name: 'Biobot Analytics',
    logo: biobot,
    description:
      'Biobot Analytics analyze sewage with molecular technologies and AI to provide early warning of population health threats across the globe',
    focusArea: 'Other',
    href: 'https://biobot.io/',
  },
  {
    name: 'Antares',
    logo: antaresLogo,
    focusArea: 'Other',
    featured: true,
    href: 'https://www.antaresindustries.com/',
  },
  {
    name: 'Space Perspective',
    logo: spacePerspectiveLogo,
    focusArea: 'Other',
    featured: true,
    href: 'https://spaceperspective.com/',
  },
];
